import { createPortal } from 'react-dom';
import React from 'react';

const getRoot = () => {
  let el = document.getElementById('vq-modal-root');
  if (!el) {
    el = document.createElement('div');
    el.id = 'vq-modal-root';
    document.body.appendChild(el);
  }
  return el;
};

export default function VQModal({ children, wide = false, ...rest }) {
  return createPortal(
    <div className="vq-modal" role="dialog" aria-modal="true" {...rest}>
      <div className="vq-modal__backdrop" />
      <div className={`vq-modal__card${wide ? ' vq-modal__card--wide' : ''}`}>
        {children}
      </div>
    </div>,
    getRoot()
  );
}
